import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import splash from '../assets/images/landing/code2.jpg';
import './LandingPage.css'
import './Cube.css'

class Cube extends Component {
  render() {
    return (
      <div className="wrap">
        <div className="cube spin-horizontal">
          <div className={`cube-face front-face`}></div>
          <div className={`cube-face back-face`}></div>
          <div className={`cube-face top-face`}></div>
          <div className={`cube-face bottom-face`}></div>
          <div className={`cube-face left-face`}></div>
          <div className={`cube-face right-face`}></div>
        </div>
      </div>
    )
  }
}
export default class LandingPage extends Component {
  render() {
    return (
      <div className='landing-page' id="landing">
        <div className="my-info">
          <h2>Hi, I'm Nick.</h2>
          <p>I am a web technologist specializing in building custom React interfaces.</p>
        </div>
        <Link className="btn fix-hover" to="/contact">Get in touch</Link>
        <img src={splash} className="splash-img" alt="landing img" />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/LandingPage.js